export const PAGE_URLS = {
  DASHBOARD: "/dashboard",
  SEARCH_CLIENT: "/client-search",
  CREATE_CLIENT: "/create-client",
  SEARCH_PROJECT: "/project-search",
  CREATE_PROJECT: "/create-project",
  EDIT_PROJECT: "/edit-project",
  VIEW_PROJECT: "/view-project",
  EDIT_CLIENT: "/edit-client",
  VIEW_CLIENT: "/view-client",
  CREATE_PROGRAM_TEMPLATE: "/create-program-template",
  PROGRAM_TEMPLATE: "/program-template",
  VIEW_PROGRAM_TEMPLATE: "/view-program-template",
  VIEW_PROGRAM: "/view-program",
  EDIT_PROGRAM_TEMPLATE: "/edit-program-template",
  CREATE_PROGRAM: "/create-program",
  CREATE_NIS_PARTICIPANT: "/create-nis-participant",
  VIEW_NIS_PARTICIPANT: "/view-nis-participant",
  EDIT_NIS_PARTICIPANT: "/edit-nis-participant",
  CREATE_NIP3_CANDIDATE: "/create-nip3-candidate",
  SEARCH_PROGRAM: "/search-program",
  EDIT_PROGRAM: "/edit-program",
  CREATE_BULK_ACTIVITY: "/create-bulk-activity",
  CREATE_BULK_TRANSFER: "/create-bulk-transfer",
  GENERIC_ACCOUNTS_SEARCH: "/generic-accounts-search",
  CREATE_GENERIC_ACCOUNTS: "/create-generic-accounts",
  EDIT_GENERIC_ACCOUNTS: "/edit-generic-accounts",
  VIEW_GENERIC_ACCOUNT: "/view-generic-account",
  VIEW_PARTICIPANT: "/view-participant",
  EDIT_PARTICIPANT: "/edit-participant",
  MDM_ACTIVITY: "/mdm-activity",
  MDM_OFFICE: "/mdm-office",
  REPORTS: "/reports",
  BULK_CREATE_PROGRAM: "/bulk-create-program",
  COACH_PORTAL_SEARCH_PARTICIPANTS: "/search-participants",
  COACH_PORTAL_DASHBOARD: "/coach-dashboard",
  COACH_PORTAL_VIEW_PARTICIPANT: "/coach-portal-view-participant",
  COACH_PORTAL_EDIT_PARTICIPANT: "/coach-portal-edit-participant",
  SEARCH_USERS: "/search-users",
  MANAGE_BULK_PROCESS: "/manage-bulk-process",
  BULK_EDIT_PROGRAM: "/bulk-edit-program",
  BULK_CREATE_PROGRAM_DETAILS: "/bulk-create-program-details",
  BULK_EDIT_PROGRAM_DETAILS: "/bulk-edit-program-details",
  BULK_INSERT_ACTIVITY_DETAILS: "/bulk-insert-activity-details",
  BULK_TRANSFER_PARTICIPANTS_DETAILS: "/bulk-transfer-participants-details",
  SYSTEM_MESSAGES: "/system-messages",
  CLIENT_PORTAL_SETUP_ACCOUNTS: "/client_portal_setup/accounts",

  CLIENT_PORTAL_SETUP_ACCOUNTS_CLIENT_ACCOUNT:
    "/client_portal_setup/accounts/client_acc",
  CLIENT_PORTAL_SETUP_ACCOUNTS_CLIENT_ACCOUNT_VIEW:
    "/client_portal_setup/accounts/client_acc/view",
  CLIENT_PORTAL_SETUP_ACCOUNTS_CLIENT_ACCOUNT_CREATE:
    "/client_portal_setup/accounts/client_acc/create",
  CLIENT_PORTAL_SETUP_ACCOUNTS_CLIENT_ACCOUNT_EDIT:
    "/client_portal_setup/accounts/client_acc/edit/:id",

  CLIENT_PORTAL_SETUP_ACCOUNTS_CLIENT_SUB_ACCOUNT:
    "/client_portal_setup/accounts/client_sub_acc",
  CLIENT_PORTAL_SETUP_ACCOUNTS_CLIENT_SUB_ACCOUNT_VIEW:
    "/client_portal_setup/accounts/client_sub_acc/view",
  CLIENT_PORTAL_SETUP_ACCOUNTS_CLIENT_SUB_ACCOUNT_CREATE:
    "/client_portal_setup/accounts/client_sub_acc/create",
  CLIENT_PORTAL_SETUP_ACCOUNTS_CLIENT_SUB_ACCOUNT_EDIT:
    "/client_portal_setup/accounts/client_sub_acc/edit/:id",

  CLIENT_PORTAL_SETUP_REPORTS: "/client_portal_setup/reports",
  CLIENT_PORTAL_SETUP_REPORTS_CLIENT_SPECIFIC_REPORT:
    "/client_portal_setup/reports/client_specific_report",
  CLIENT_PORTAL_SETUP_REPORTS_CLIENT_SPECIFIC_REPORT_VIEW:
    "/client_portal_setup/reports/client_specific_report/view",
  CLIENT_PORTAL_SETUP_REPORTS_CLIENT_SPECIFIC_REPORT_CREATE:
    "/client_portal_setup/reports/client_specific_report/create",
  CLIENT_PORTAL_SETUP_REPORTS_CLIENT_SPECIFIC_REPORT_EDIT:
    "/client_portal_setup/reports/client_specific_report/edit/:id",

  CLIENT_PORTAL_SETUP_REPORTS_THOUGHT_LEADERSHIP_RESOURCES:
    "/client_portal_setup/reports/thought_leadership_resources",
  CLIENT_PORTAL_SETUP_REPORTS_THOUGHT_LEADERSHIP_RESOURCES_VIEW:
    "/client_portal_setup/reports/thought_leadership_resources/view",
  CLIENT_PORTAL_SETUP_REPORTS_THOUGHT_LEADERSHIP_RESOURCES_EDIT:
    "/client_portal_setup/reports/thought_leadership_resources/edit/:sitecoreId",

  CLIENT_PORTAL_SETUP_PROGRAMME_DESCRIPTOR:
    "/client_portal_setup/programme_descriptor",
  CLIENT_PORTAL_SETUP_PROGRAMME_DESCRIPTOR_CLIENT_ACC_PD:
    "/client_portal_setup/programme_descriptor/client_acc_pd",
  CLIENT_PORTAL_SETUP_PROGRAMME_DESCRIPTOR_CLIENT_ACC_PD_VIEW:
    "/client_portal_setup/programme_descriptor/client_acc_pd/view",
  CLIENT_PORTAL_SETUP_PROGRAMME_DESCRIPTOR_CLIENT_ACC_PD_CREATE:
    "/client_portal_setup/programme_descriptor/client_acc_pd/create",
  CLIENT_PORTAL_SETUP_PROGRAMME_DESCRIPTOR_CLIENT_ACC_PD_EDIT:
    "/client_portal_setup/programme_descriptor/client_acc_pd/edit/:id",
  CLIENT_PORTAL_SETUP_PROGRAMME_DESCRIPTOR_CLIENT_ACC_PD_ADD_CUSTOM_RESOURCE:
    "/client_portal_setup/programme_descriptor/client_acc_pd/addCustomResource/:clientAccountId",
  CLIENT_PORTAL_SETUP_PROGRAMME_DESCRIPTOR_CLIENT_ACC_PD_FOLDER_VIEW:
    "/client_portal_setup/programme_descriptor/client_acc_pd/folder/view/:id",

  CLIENT_PORTAL_SETUP_PROGRAMME_DESCRIPTOR_MANAGE_ACC_PD:
    "/client_portal_setup/programme_descriptor/manage_acc_pd",
  CLIENT_PORTAL_SETUP_PROGRAMME_DESCRIPTOR_MANAGE_ACC_PD_VIEW:
    "/client_portal_setup/programme_descriptor/manage_acc_pd/view",
  CLIENT_PORTAL_SETUP_PROGRAMME_DESCRIPTOR_MANAGE_ACC_PD_CREATE:
    "/client_portal_setup/programme_descriptor/manage_acc_pd/create",
  CLIENT_PORTAL_SETUP_PROGRAMME_DESCRIPTOR_MANAGE_ACC_PD_EDIT:
    "/client_portal_setup/programme_descriptor/manage_acc_pd/edit/:id",
  CLIENT_PORTAL_SETUP_PROGRAMME_DESCRIPTOR_MANAGE_ACC_PD_RECYCLE:
    "/client_portal_setup/programme_descriptor/manage_acc_pd/recycle",

  CLIENT_PORTAL_SETUP_REFERRALS: "/client_portal_setup/referrals",
  CLIENT_PORTAL_SETUP_REFERRALS_ASSIGN_REFERRAL_REQ:
    "/client_portal_setup/referrals/assign_referral_req",
  CLIENT_PORTAL_SETUP_REFERRALS_ASSIGN_REFERRAL_REQ_VIEW:
    "/client_portal_setup/referrals/assign_referral_req/view",
  CLIENT_PORTAL_SETUP_REFERRALS_ASSIGN_REFERRAL_REQ_EDIT:
    "/client_portal_setup/referrals/assign_referral_req/edit/:id",

  CLIENT_PORTAL_SETUP_REFERRALS_MANAGE_REFERRAL_REQ:
    "/client_portal_setup/referrals/manage_referral_req",
  CLIENT_PORTAL_SETUP_REFERRALS_MANAGE_REFERRAL_REQ_VIEW:
    "/client_portal_setup/referrals/manage_referral_req/view",
  CLIENT_PORTAL_SETUP_REFERRALS_MANAGE_REFERRAL_REQ_EDIT:
    "/client_portal_setup/referrals/manage_referral_req/edit/:id",

  CLIENT_PORTAL_SETUP_ACC_TEAM: "/client_portal_setup/acc_team",
  CLIENT_PORTAL_SETUP_ACC_TEAM_VIEW: "/client_portal_setup/acc_team/view",
  CLIENT_PORTAL_SETUP_ACC_TEAM_CREATE: "/client_portal_setup/acc_team/create",
  CLIENT_PORTAL_SETUP_ACC_TEAM_EDIT: "/client_portal_setup/acc_team/edit/:id",

  CLIENT_PORTAL_SETUP_MEETING_REQUESTS: "/client_portal_setup/meeting_requests",
  CLIENT_PORTAL_SETUP_MEETING_REQUESTS_VIEW:
    "/client_portal_setup/meeting_requests/view",
  CLIENT_PORTAL_SETUP_MEETING_REQUESTS_EDIT:
    "/client_portal_setup/meeting_requests/edit/:id",

  CLIENT_PORTAL_SETUP_ADMIN_MESSAGES: "/client_portal_setup/admin_messages",
  CLIENT_PORTAL_SETUP_ADMIN_MESSAGES_VIEW:
    "/client_portal_setup/admin_messages/view",
  CLIENT_PORTAL_SETUP_ADMIN_MESSAGES_CREATE:
    "/client_portal_setup/admin_messages/create",
  CLIENT_PORTAL_SETUP_ADMIN_MESSAGES_EDIT:
    "/client_portal_setup/admin_messages/edit/:id",

  CLIENT_PORTAL_SETUP_CLIENT_USERS: "/client_portal_setup/client_users",
  CLIENT_PORTAL_SETUP_CLIENT_USERS_VIEW:
    "/client_portal_setup/client_users/view",
  CLIENT_PORTAL_SETUP_CLIENT_USERS_CREATE:
    "/client_portal_setup/client_users/create",
  CLIENT_PORTAL_SETUP_CLIENT_USERS_EDIT:
    "/client_portal_setup/client_users/edit/:id",
};

export const SITE_CORE_PAGE_NAME = {
  SEARCH_CLIENT: "SearchClient",
  CREATE_CLIENT: "CreateClient",
  PROGRAM_TEMPLATE: "SearchProgramTemplate",
  CREATE_PROGRAM_TEMPLATE: "CreateProgramTemplate",
  VIEW_PROGRAM_TEMPLATE: "CreateProgramTemplate",
  EDIT_PROGRAM_TEMPLATE: "CreateProgramTemplate",
  SEARCH_PROGRAM: "SearchProgramAndCandidate",
  CREATE_PROGRAM: "CreateProgram",
  CREATE_NIS_PARTICIPANT: "CreateNewNISParticipant",
  VIEW_NIS_PARTICIPANT: "CreateNewNISParticipant",
  EDIT_NIS_PARTICIPANT: "CreateNewNISParticipant",
  VIEW_PROGRAM: "CreateProgram",
  EDIT_PROGRAM: "CreateProgram",
  CREATE_BULK_ACTIVITY: "ParticipantsAddBulkActivity",
  CREATE_BULK_TRANSFER: "BulkTransferParticipants",
  GENERIC_ACCOUNTS_SEARCH: "SearchGenericAccount",
  GENERIC_ACCOUNTS_CREATE: "CreateGenericAccount",
  REGISTERED_PARTICIPANTS: "RegisteredParticipants",
  MDM_ACTIVITY: "MDMActivity",
  MDM_OFFICE: "MDMOffice",
  REPORT: "Reports",
  BULK_CREATE_PROGRAM: "BulkCreateProgram",
  COACH_PORTAL_SEARCH_PARTICIPANTS: "CoachSearchParticipants",
  COACH_PORTAL_DASHBOARD: "CoachDashboard",
  COACH_PORTAL_VIEW_PARTICIPANT: "CoachManageParticipants",
  COACH_PORTAL_EDIT_PARTICIPANT: "CoachManageParticipants",
  SEARCH_USERS: "Users",
  MANAGE_BULK_PROCESS: "ManageBulkProcess",
  BULK_EDIT_PROGRAM: "BulkEditProgram",
  SEARCH_PROJECT: "SearchProjects",
  SYSTEM_MESSAGES: "SystemMessages",
  CREATE_PROJECT: "CreateNewProject",
  EDIT_PROJECT: "CreateNewProject",
  VIEW_PROJECT: "CreateNewProject",
};

export const PAGE_NAME_BY_ROUTE_MAPPING = {
  [PAGE_URLS.SEARCH_CLIENT]: SITE_CORE_PAGE_NAME.SEARCH_CLIENT,
  [PAGE_URLS.CREATE_CLIENT]: SITE_CORE_PAGE_NAME.CREATE_CLIENT,
  [PAGE_URLS.EDIT_CLIENT]: SITE_CORE_PAGE_NAME.CREATE_CLIENT,
  [`${PAGE_URLS.VIEW_CLIENT}/:id`]: SITE_CORE_PAGE_NAME.CREATE_CLIENT,
  [PAGE_URLS.PROGRAM_TEMPLATE]: SITE_CORE_PAGE_NAME.PROGRAM_TEMPLATE,
  [PAGE_URLS.CREATE_PROGRAM_TEMPLATE]:
    SITE_CORE_PAGE_NAME.CREATE_PROGRAM_TEMPLATE,
  [`${PAGE_URLS.VIEW_PROGRAM_TEMPLATE}/:id`]:
    SITE_CORE_PAGE_NAME.VIEW_PROGRAM_TEMPLATE,
  [`${PAGE_URLS.EDIT_PROGRAM_TEMPLATE}/:id`]:
    SITE_CORE_PAGE_NAME.EDIT_PROGRAM_TEMPLATE,
  [`${PAGE_URLS.VIEW_PROGRAM}/:id`]: SITE_CORE_PAGE_NAME.VIEW_PROGRAM,
  [PAGE_URLS.SEARCH_PROGRAM]: SITE_CORE_PAGE_NAME.SEARCH_PROGRAM,
  [PAGE_URLS.CREATE_PROGRAM]: SITE_CORE_PAGE_NAME.CREATE_PROGRAM,
  [PAGE_URLS.CREATE_NIS_PARTICIPANT]:
    SITE_CORE_PAGE_NAME.CREATE_NIS_PARTICIPANT,
  [`${PAGE_URLS.VIEW_NIS_PARTICIPANT}/:id`]:
    SITE_CORE_PAGE_NAME.VIEW_NIS_PARTICIPANT,
  [`${PAGE_URLS.EDIT_NIS_PARTICIPANT}/:id`]:
    SITE_CORE_PAGE_NAME.EDIT_NIS_PARTICIPANT,
  [`${PAGE_URLS.EDIT_PROGRAM}/:id`]: SITE_CORE_PAGE_NAME.EDIT_PROGRAM,
  [`${PAGE_URLS.CREATE_BULK_ACTIVITY}`]:
    SITE_CORE_PAGE_NAME.CREATE_BULK_ACTIVITY,
  [`${PAGE_URLS.CREATE_BULK_TRANSFER}`]:
    SITE_CORE_PAGE_NAME.CREATE_BULK_TRANSFER,
  [PAGE_URLS.GENERIC_ACCOUNTS_SEARCH]:
    SITE_CORE_PAGE_NAME.GENERIC_ACCOUNTS_SEARCH,
  [PAGE_URLS.GENERIC_ACCOUNTS_SEARCH]:
    SITE_CORE_PAGE_NAME.GENERIC_ACCOUNTS_SEARCH,
  [PAGE_URLS.CREATE_GENERIC_ACCOUNTS]:
    SITE_CORE_PAGE_NAME.GENERIC_ACCOUNTS_CREATE,
  [PAGE_URLS.EDIT_GENERIC_ACCOUNTS]:
    SITE_CORE_PAGE_NAME.GENERIC_ACCOUNTS_CREATE,
  [PAGE_URLS.VIEW_GENERIC_ACCOUNT]: SITE_CORE_PAGE_NAME.GENERIC_ACCOUNTS_CREATE,
  [PAGE_URLS.VIEW_PARTICIPANT]: SITE_CORE_PAGE_NAME.REGISTERED_PARTICIPANTS,
  [PAGE_URLS.EDIT_PARTICIPANT]: SITE_CORE_PAGE_NAME.REGISTERED_PARTICIPANTS,
  [PAGE_URLS.MDM_ACTIVITY]: SITE_CORE_PAGE_NAME.MDM_ACTIVITY,
  [PAGE_URLS.MDM_OFFICE]: SITE_CORE_PAGE_NAME.MDM_OFFICE,
  [PAGE_URLS.REPORTS]: SITE_CORE_PAGE_NAME.REPORT,
  [PAGE_URLS.BULK_CREATE_PROGRAM]: SITE_CORE_PAGE_NAME.BULK_CREATE_PROGRAM,
  [PAGE_URLS.COACH_PORTAL_DASHBOARD]:
    SITE_CORE_PAGE_NAME.COACH_PORTAL_DASHBOARD,
  [PAGE_URLS.COACH_PORTAL_SEARCH_PARTICIPANTS]:
    SITE_CORE_PAGE_NAME.COACH_PORTAL_SEARCH_PARTICIPANTS,
  [PAGE_URLS.SEARCH_USERS]: SITE_CORE_PAGE_NAME.SEARCH_USERS,
  [`${PAGE_URLS.COACH_PORTAL_VIEW_PARTICIPANT}/:id`]:
    SITE_CORE_PAGE_NAME.COACH_PORTAL_VIEW_PARTICIPANT,
  [`${PAGE_URLS.COACH_PORTAL_EDIT_PARTICIPANT}/:id`]:
    SITE_CORE_PAGE_NAME.COACH_PORTAL_VIEW_PARTICIPANT,
  [PAGE_URLS.MANAGE_BULK_PROCESS]: SITE_CORE_PAGE_NAME.MANAGE_BULK_PROCESS,
  [PAGE_URLS.BULK_EDIT_PROGRAM]: SITE_CORE_PAGE_NAME.BULK_EDIT_PROGRAM,
  [PAGE_URLS.BULK_CREATE_PROGRAM_DETAILS]:
    SITE_CORE_PAGE_NAME.BULK_CREATE_PROGRAM,
  [PAGE_URLS.BULK_EDIT_PROGRAM_DETAILS]: SITE_CORE_PAGE_NAME.BULK_EDIT_PROGRAM,
  [PAGE_URLS.BULK_INSERT_ACTIVITY_DETAILS]:
    SITE_CORE_PAGE_NAME.CREATE_BULK_ACTIVITY,
  [PAGE_URLS.BULK_TRANSFER_PARTICIPANTS_DETAILS]:
    SITE_CORE_PAGE_NAME.CREATE_BULK_TRANSFER,
  [PAGE_URLS.SEARCH_PROJECT]: SITE_CORE_PAGE_NAME.SEARCH_PROJECT,
  [PAGE_URLS.SYSTEM_MESSAGES]: SITE_CORE_PAGE_NAME.SYSTEM_MESSAGES,
  [PAGE_URLS.CREATE_PROJECT]: SITE_CORE_PAGE_NAME.CREATE_PROJECT,
  [`${PAGE_URLS.EDIT_PROJECT}/:id`]: SITE_CORE_PAGE_NAME.EDIT_PROJECT,
  [`${PAGE_URLS.VIEW_PROJECT}/:id`]: SITE_CORE_PAGE_NAME.VIEW_PROJECT,
};

// assigning id's to every page
export const PAGE_IDS = {
  CREATE_PROJECT: "create-project",
  EDIT_PROJECT: "edit-project",
  SEARCH_PROJECT: "project-search",
  VIEW_PROJECT: "view-project",
  SEARCH_CLIENT: "client-search",
  CREATE_CLIENT: "create-client",
  VIEW_CONTACT: "view-contact",
  PROGRAM_TEMPLATE: "program-template-search",
  VIEW_PROGRAM_TEMPLATE: "view-program-template",
  VIEW_PROGRAM: "view-program",
  CREATE_CLIENT_PROFILE: "create-client-profile",
  CREATE_CLIENT_ACTIVITY_DELIVERABLES: "create-client-activity-deliverables",
  CREATE_CLIENT_MAILING_ADDRESS: "create-client-mailing-address",
  CREATE_CLIENT_BILLING_CONFIGURATION: "create-client-billing-configuration",
  CREATE_CLIENT_CONTACT_RESULT: "create-client-contact-result",
  CREATE_CLIENT_CLIENT_SPECIFIC_CONTENT_LIST:
    "create-client-client-specific-content-list",
  BILLING_AND_PURCHASE_ORDER: "billing-and-purchase-order",
  CREATE_PROGRAM_TEMPLATE: "create-program-template",
  BILLING_DETAILS: "billing-details",
  ADD_CLIENT_SPECIFIC_CONTENT: "add-client-specific-content",
  VIEW_CLIENT_SPECIFIC_CONTENT: "view-client-specific-content",
  VIEW_CLIENT_SPECIFIC_CONTENT_PROGRAM_TEMPLATE:
    "view-client-specific-content-program-template",
  CREATE_RESOURCE: "create-resource",
  CLIENT_SPECIFIC_CONTENT_PROGRAM_TEMPLATE:
    "client-specific-content-program-template",
  VIEW_RESOURCE: "view-resource",
  UPLOAD_DOCUMENT: "upload-document",
  INHERIT_DOCUMENTS_SEARCH: "inherit-documents-search",
  INHERIT_DOCUMENTS_SEARCH_RESULT: "inherit-documents-search-result",
  ADD_NEW_CONTACT: "add-new-contact",
  VIEW_DOCUMENT: "view-document",
  CREATE_PROGRAM: "/create-program",
  PROGRAM_UPLOAD_DOCUMENT: "program-upload-document",
  PROGRAM_VIEW_DOCUMENT: "program-view-document",
  CREATE_NIS_PARTICIPANT: "create-nis-participant",
  EDIT_NIS_PARTICIPANT: "edit-nis-participant",
  VIEW_NIS_PARTICIPANT: "view-nis-participant",
  CREATE_NIS_PARTICIPANT_PROFILE: "create-nis-participant-profile",
  CREATE_NIS_PARTICIPANT_PROFESSIONAL_DETAILS:
    "create-nis-participant-professional-details",
  CREATE_NIS_PARTICIPANT_ADDRESS_DETAILS:
    "create-nis-participant-address-details",
  CREATE_NIS_PARTICIPANT_NIS_STATUS: "create-nis-participant-nis-status",
  NIS_STATUS_RESULT: "nis-status-result",
  CHANGE_NIS_STATUS: "change-nis-status",
  CREATE_PROGRAM_GOAL_SELECTION_RESULT: "goal-selection-result",
  VIEW_GOAL_MODAL: "view-goal-modal",
  CREATE_NIP3_CANDIDATE: "/create-nip3-candidate",
  SEARCH_PROGRAM: "search-program",
  CANCEL_CONTRACT_MODAL: "cancel-contract-modal",
  PURCHASE_ORDER_LIST: "purchase-order-list",
  ADD_PURCHASE_ORDER: "add-purchase-order",
  VIEW_PURCHASE_ORDER: "view-purchase-order",
  PO_MANAGE_TRANSACTIONS: "po-manage-transactions",
  EDIT_PROGRAM: "edit-program",
  VIEW_PROFILE: "view-profile",
  VIEW_BILLING_CONFIGURATION: "view-billing-configuration",
  CREATE_BULK_ACTIVITY: "create-bulk-activity",
  CREATE_BULK_TRANSFER: "create-bulk-transfer",
  GENERIC_ACCOUNTS_SEARCH: "generic-accounts-search",
  GENERIC_ACCOUNTS_RESULT: "generic-accounts-result",
  CREATE_GENERIC_ACCOUNT: "create-generic-accounts",
  EDIT_GENERIC_ACCOUNT: "edit-generic-accounts",
  CREATE_GENERIC_ACCOUNT_CONFIG_FEATURES:
    "create-generic-accounts-config-features",
  GENERIC_ACCOUNT_VIEW: "view-generic-account",
  VIEW_PARTICIPANT: "view-participant",
  EDIT_PARTICIPANT: "edit-participant",
  REGISTERED_PARTICIPANT_TAB: "registered-participant-tab",
  RAISE_INVOICE: "raise-invoice",
  MDM_ACTIVITY_SEARCH: "mdm-activity-search",
  MDM_ADD_ACTIVITY: "mdm-add-activity",
  MDM_VIEW_ACTIVITY: "mdm-view-activity",
  MDM_ADD_TOPIC: "mdm-add-topic",
  MDM_OFFICE_DETAILS: "mdm-office-details",
  MDM_INVOICING_DETAILS: "mdm-invoicing-details",
  MDM_ADDRESS_AND_CONTACT_DETAILS: "mdm-address-and-contact-details",
  MDM_OFFICE_SEARCH: "mdm-office-search",
  MDM_OFFICE_SEARCH_HEADER: "mdm-office-search-header",
  REPORTS: "reports",
  MDM_VIEW_TOPIC: "mdm-view-topic",
  BULK_CREATE_PROGRAM: "bulk-create-program",
  MANAGE_BULK_PROGRAM_PROCESS: "manage-bulk-program-process",
  SEARCH_PARTICIPANTS: "search-participants",
  COACH_PORTAL_DASHBOARD_MAIN: "coach-portal-dashboard-main",
  COACH_PORTAL_DASHBOARD_HEADER: "coach-portal-dashboard-header",
  COACH_PORTAL_DASHBOARD_HEADER_PARTICIPANT_LANDED:
    "coach-portal-dashboard-header-participant-landed",
  COACH_PORTAL_DASHBOARD_MY_CASELOADS: "coach-portal-dashboard-my-caseloads",
  COACH_PORTAL_DASHBOARD_MY_CASELOADS_VS_ENGAGEMENTS:
    "coach-portal-dashboard-my-caseloads-vs-engagements",
  COACH_PORTAL_DASHBOARD_MY_CASELOADS_RESULTS:
    "coach-portal-dashboard-my-caseloads-results",
  COACH_PORTAL_DASHBOARD_MY_MEETINGS: "coach-portal-dashboard-my-meetings",
  SEARCH_PARTICIPANTS_RESULTS: "search-participants-results",
  MANAGE_PARTICIPANTS_MAIN: "manage-participants-main",
  COACH_PORTAL_MANAGE_PARTICIPANTS_ADD_ACTIVITY_FORM:
    "manage-participants-add-activity-form",
  SEARCH_USERS: "search-users",
  CREATE_USER: "create-user",
  MANAGE_BULK_PROCESS: "manage-bulk-process",
  BULK_EDIT_PROGRAM: "bulk-edit-program",
  SYSTEM_MESSAGES: "system-messages",
  CREATE_SYSTEM_MESSAGE: "create-system-message",
  VIEW_SYSTEM_MESSAGE: "view-system-message",
  PROJECT_FACILITATOR: "project-facilitator",
  PROJECT: "project",
  CREATE_PROJECT_CHILD_PROGRAMS_TAB: "create-project-child-programs-tab",
  CREATE_PROJECT_CHILD_PROGRAMS_LIST: "create-project-child-programs-list",
  ADD_EXISTING_PROGRAM_SEARCH_RESULT: "add-existing-program-search-result",
  MANAGE_REVENUE_SPLIT: "manage-revenue-split",
  ARCHIVE_CONTRACT_MODAL: "archive-contract-modal",

  COACH_PORTAL_EDIT_PARTICIPANT: "coach-portal-edit-participant",
  COACH_PORTAL_EDIT_PARTICIPANT_ACTIVITY_TIMELINE:
    "coach-portal-edit-participant-activity-timeline",
  COACH_PORTAL_EDIT_PARTICIPANT_SESSION_EVENTS:
    "coach-portal-edit-participant-session-events",
  COACH_PORTAL_MANAGE_PARTICIPANTS_ADD_ACTIVITY:
    "coach-portal-manage-participants-add-activity",

  COACH_PORTAL_VIEW_PARTICIPANT: "coach-portal-view-participant",
  COACH_PORTAL_VIEW_PARTICIPANT_ACTIVITY_TIMELINE:
    "coach-portal-view-participant-activity-timeline",
  COACH_PORTAL_VIEW_PARTICIPANT_SESSION_EVENTS:
    "coach-portal-view-participant-session-events",
  COACH_PORTAL_VIEW_PARTICIPANT_ADD_ACTIVITY:
    "coach-portal-view-participant-add-activity",
};

export const PAGE_NAME_FOR_COUNTRY_DROPDOWN = {
  CLIENT: "clientPage",
  PROGRAM: "programPage",
  BULK_PROCESS: "bulkProcess",
  PROJECT: "projectPage",
  NIS_PARTICIPANT: "nisParticipantPage",
};

export const PAGE_OPERATION_TYPE = {
  ADD: "add",
  EDIT: "edit",
  VIEW: "view",
};
